import React from "react";
import Button from "src/0-app/2-component/Button";
import styled from "styled-components";
import {FAQs} from "src/components/portal/_shared/components/FAQs";

const SOCAL_FIRE_REBUILDS_ORDER_FEASIBILITY_URL =
  "https://buy.stripe.com/bIYdUl9mH8P47zGcMV";
  
const SocailFireSummaryBlocker = ({firstName, email}: {firstName: string | undefined, email: string | undefined}) => {
    const welcomeMessage = firstName ? `Welcome, ${firstName}` : "Welcome";
  return (
    <div
      style={{
        padding: "32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Heading>{welcomeMessage}</Heading>
      <Paragraph>
        Our expert team is here to help you navigate your rebuild. Here are some
        helpful links for getting started.
      </Paragraph>
      <Paragraph style={{marginBottom: "48px"}}>
        Ready for the next step? Order an in-depth{" "}
        <Paragraph
          as="a"
          href="/feasibility-study"
          style={{textDecoration: "underline"}}
        >
          Feasibility Study
        </Paragraph>
        , which includes site plan, permit review, design recommendations, and
        an estimated budget.
      </Paragraph>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "16px",
          marginBottom: "16px",
        }}
      >
        <Button
          id="order-feasibility-study"
          label="Browse homes"
          size="large"
          style={{minWidth: "217px"}}
          onClick={() => {
            window.open("/socal-fire-rebuilds");
          }}
        />
        <Button
          id={"socal_fire_rebuilds_order_feasibility"}
          data-cy={"socal_fire_rebuilds_order_feasibility"}
          label={"Order Feasibility Study"}
          theme="secondary"
          size={"large"}
          style={{minWidth: "217px"}}
          onClick={() => {
            window.open(
              email
                ? SOCAL_FIRE_REBUILDS_ORDER_FEASIBILITY_URL +
                    "?prefilled_email=" +
                    email
                : SOCAL_FIRE_REBUILDS_ORDER_FEASIBILITY_URL
            );
          }}
        />
      </div>
      <Link href="/products" style={{marginBottom: "64px"}}>
        Interested in an ADU? Browse our catalog.
      </Link>
      <div style={{width: "100%", maxWidth: "800px"}}>
        <FAQs
          defaultExpanded={false}
          stripeUrlOverride={SOCAL_FIRE_REBUILDS_ORDER_FEASIBILITY_URL}
        />
      </div>
    </div>
  );
};

const Heading = styled.h2`
  color: #000;

  /* display-large/semibold */
  font-family: p22-mackinac-pro;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 56px; /* 116.667% */
  letter-spacing: -0.96px;
  margin-bottom: 24px;
`;

const Paragraph = styled.p`
  color: #5a4e4e;
  text-align: center;

  /* headline-small/regular */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 450;
  line-height: 22px; /* 137.5% */
  max-width: 800px;
  margin-bottom: 16px;
`;

const Link = styled.a`
  color: #000;

  /* body-medium/regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 26px; /* 162.5% */
  letter-spacing: 0.16px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export default SocailFireSummaryBlocker;